/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ActionPerformer = 'SYSTEM' | 'OPERATOR';

export const ActionPerformer = {

    SYSTEM: 'SYSTEM' as ActionPerformer,

    OPERATOR: 'OPERATOR' as ActionPerformer
};

